import { ELanguages } from "@honzachalupa/utils";

export const ESupportedLanguages: typeof ELanguages = [
    ELanguages.find(({ id }) => id === "cs")!,
    // ELanguages.find(({ id }) => id === "sk")!,
];
